import { Pipe, PipeTransform } from '@angular/core';
import { SnakeToTitleCase } from '../../utils/snake-to-title-case';

@Pipe({
  name: 'snakeCaseToTitle',
  pure: false,
})
export class SnakeCaseToTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return SnakeToTitleCase(value);
  }
}
